'use client';

import { IUniversityData, UniversityGridPage } from '@into-discovery/browsewebshared';
import { appBranding } from '@/data/application-branding';
import { Container } from 'react-bootstrap';
import { useLocale } from 'next-intl';

type UniversityGridProviderProps = {
  universityData: IUniversityData[];
};

export function UniversityGridProvider({
  universityData: universities,
}: UniversityGridProviderProps) {
  const locale = useLocale();

  // TODO: Refactor the type, it's called IUniversityCard in BW
  const getUniversityLandingLink = (university: IUniversityData) => {
    return university.clavelUrl
      ? `https://${university.clavelUrl}/${locale}/`
      : `/${locale}/universities/` + university.slug;
  };

  return (
    <Container>
      <div id="universities">
        {universities.length ? (
          <UniversityGridPage
            appBranding={appBranding}
            universityData={universities}
            uniListingsShowEntryRouteFilters={false}
            showEntryRoutePills={false}
            getUniversityLandingLink={getUniversityLandingLink}
          />
        ) : null}
      </div>
    </Container>
  );
}
